function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from '../../_snowpack/pkg/react.js';

function SvgComponent(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 34.016 34.016"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "#daf0ed",
    d: "M12.706 16.125l-.1-11.782M16.3 4.44h-3.394M12.701 4.437h16.9v16.85h-16.9z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M28.96 4.471v11.654a.637.637 0 0 0 1.273 0V4.471a.641.641 0 0 0-1.281 0zM13.331 16.125c0-3.926.071-7.859-.082-11.782a.543.543 0 0 0-1.086 0c-.153 3.923-.081 7.856-.082 11.782a.625.625 0 0 0 1.25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M13.334 21.285v-5.16a.625.625 0 0 0-1.25 0v5.16a.629.629 0 0 0 1.257 0zM29.6 21.917a.633.633 0 0 0 0-1.265.633.633 0 0 0 0 1.265z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M28.964 16.125v5.16a.633.633 0 0 0 1.265 0v-5.16a.637.637 0 0 0-1.273 0zM16.3 20.656h-3.594a.625.625 0 0 0 0 1.25H16.3a.629.629 0 0 0 0-1.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M20.951 20.656H16.3a.629.629 0 0 0 0 1.257h4.651a.629.629 0 0 0 0-1.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M29.6 20.652h-8.649a.629.629 0 0 0 0 1.257H29.6a.633.633 0 0 0 0-1.265zM16.3 3.812h-3.394a.625.625 0 0 0 0 1.25H16.3a.629.629 0 0 0 0-1.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M20.951 3.812H16.3a.629.629 0 0 0 0 1.257h4.651a.629.629 0 0 0 0-1.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M29.6 3.808h-8.649a.629.629 0 0 0 0 1.257H29.6a.633.633 0 0 0 0-1.265z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M28.96 4.471v11.654a.637.637 0 0 0 1.273 0V4.471a.641.641 0 0 0-1.281 0zM13.331 16.125c-.035-3.927 0-7.86-.182-11.782a.543.543 0 0 0-1.086 0c-.12 3.924-.014 7.856.018 11.782a.625.625 0 0 0 1.25 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M13.334 21.285v-5.16a.625.625 0 0 0-1.25 0v5.16a.629.629 0 0 0 1.257 0zM29.6 21.917a.633.633 0 0 0 0-1.265.633.633 0 0 0 0 1.265z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M28.964 16.125v5.16a.633.633 0 0 0 1.265 0v-5.16a.637.637 0 0 0-1.273 0zM16.3 20.656h-3.594a.625.625 0 0 0 0 1.25H16.3a.629.629 0 0 0 0-1.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M20.951 20.656H16.3a.629.629 0 0 0 0 1.257h4.651a.629.629 0 0 0 0-1.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M29.6 20.652h-8.649a.629.629 0 0 0 0 1.257H29.6a.633.633 0 0 0 0-1.265zM16.3 3.812h-3.394a.625.625 0 0 0 0 1.25H16.3a.629.629 0 0 0 0-1.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M20.951 3.812H16.3a.629.629 0 0 0 0 1.257h4.651a.629.629 0 0 0 0-1.257z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M29.6 3.808h-8.649a.629.629 0 0 0 0 1.257H29.6a.633.633 0 0 0 0-1.265zM21.31 30.208a.633.633 0 0 0 0-1.266.633.633 0 0 0 0 1.266z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#828a90",
    d: "M20.677 27.107v2.468a.633.633 0 0 0 1.266 0v-2.468a.633.633 0 0 0-1.266 0zM20.673 21.285v2.692a.637.637 0 0 0 1.274 0v-2.692a.637.637 0 0 0-1.274 0zM5.044 16.138v-3.207a.629.629 0 0 0-1.258 0v3.207a.629.629 0 0 0 1.258 0zM5.044 23.469V20a.629.629 0 0 0-1.258 0v3.47a.629.629 0 0 0 1.258 0zM5.044 29.775v-3.091a.629.629 0 0 0-1.258 0v3.091a.629.629 0 0 0 1.258 0zM11.661 29.046H8.009a.629.629 0 0 0 0 1.258h3.652a.629.629 0 0 0 0-1.258zM17.925 29.042h-3.09a.629.629 0 0 0 0 1.258h3.09a.633.633 0 0 0 0-1.266zM10.461 12.2H7.709a.629.629 0 0 0 0 1.258h2.752a.629.629 0 0 0 0-1.258z"
  }));
}

export default SvgComponent;